function addTop40Numbers() {
  // Only run on the Top-40 collection page
  if (!window.location.pathname.includes('/collections/top-40')) return;

  const productTitles = document.querySelectorAll('.product-card__title');

  productTitles.forEach((title, i) => {
    if (!title.querySelector('.chart-number')) {
      const span = document.createElement('span');
      span.className = 'chart-number';
      span.textContent = `#${i + 1} `;
      title.prepend(span);
    }
  });
}

// Initial run
addTop40Numbers();

// Observe DOM changes (works with infinite scroll)
const observer = new MutationObserver(addTop40Numbers);
observer.observe(document.querySelector('.collection__products'), { childList: true, subtree: true });
